import { gql } from "@apollo/client";

export const MEMBER_EVENTS_REVIEW = gql`
  query adminMemberEventsReview($days: Int) {
    adminMemberEventsReview(days: $days) {
      eventId
      startDate
      zone
      isPublic
      priority
      title
      kind
      englishLevel
      hostName
      hostBadge
      isFirstPublic
      acceptedInvites
      spotsTaken
      maxParticipants
      spotsLeft
      labelsEdited
      labels {
        key
        name
        family
      }
    }
  }
`;

export const EVENT_MEMBER_MATCHES = gql`
  query adminEventMemberMatches($eventId: String!, $limit: Int, $minEnglish: String) {
    adminEventMemberMatches(eventId: $eventId, limit: $limit, minEnglish: $minEnglish) {
      eventId
      title
      labelSource
      matchBasis
      eventZone
      eventLevel
      maxParticipants
      spotsTaken
      spotsLeft
      isFull
      totalMatches
      excludedCantAccess
      englishFiltered
      quietFiltered
      newcomerFiltered
      labels {
        key
        name
        family
      }
      matches {
        userId
        name
        email
        occupation
        industry
        speakingLevel
        eventsAttended
        eventsRecent
        engagement
        englishBand
        isNewcomer
        localHour
        recentNotifs
        overContacted
        connectionScore
        storyMatch
        why
        zone
      }
    }
  }
`;

export const EVENTS_FOR_MEMBER = gql`
  query adminEventsForMember($email: String!, $days: Int, $limit: Int) {
    adminEventsForMember(email: $email, days: $days, limit: $limit) {
      member {
        userId
        name
        email
        country
        timezone
        zone
        tenureDays
        tenureBucket
        isNewcomer
        engagement
        speakingLevel
        englishBand
        occupation
        industry
        hasBio
        interests
        englishSkills
        eventsAttended
        eventsRecent
        lastOnlineAt
        upcomingBooked
        recentNotifs
        overContacted
      }
      topicMatchCount
      hiddenCantJoin
      hiddenQuietHours
      hiddenWrongLevel
      hiddenPastNewcomerWindow
      matches {
        eventId
        title
        labels {
          key
          name
          family
        }
        hostName
        hostBadge
        kind
        zone
        startsAt
        localHour
        connectionScore
        matchBasis
        inHerZone
        isFull
        spotsLeft
        why
      }
    }
  }
`;

export const EVENT_LABEL_CATALOGUE = gql`
  query adminEventLabelCatalogue {
    adminEventLabelCatalogue {
      key
      name
      family
    }
  }
`;

export const SET_EVENT_LABELS = gql`
  mutation adminSetEventLabels($title: String!, $labels: [String!]) {
    adminSetEventLabels(title: $title, labels: $labels)
  }
`;
